"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Picture_1 = require("../../atoms/Picture");

var device_desktop_apple_dark_png_1 = __importDefault(require("./images/device_desktop_apple_dark.png"));

var device_desktop_apple_light_png_1 = __importDefault(require("./images/device_desktop_apple_light.png"));

var device_laptop_apple_dark_png_1 = __importDefault(require("./images/device_laptop_apple_dark.png"));

var device_laptop_apple_light_png_1 = __importDefault(require("./images/device_laptop_apple_light.png"));

var device_phone_android_dark_png_1 = __importDefault(require("./images/device_phone_android_dark.png"));

var device_phone_android_light_png_1 = __importDefault(require("./images/device_phone_android_light.png"));

var device_phone_apple_dark_png_1 = __importDefault(require("./images/device_phone_apple_dark.png"));

var device_phone_apple_light_png_1 = __importDefault(require("./images/device_phone_apple_light.png"));

var device_tablet_apple_dark_landscape_png_1 = __importDefault(require("./images/device_tablet_apple_dark_landscape.png"));

var device_tablet_apple_dark_portrait_png_1 = __importDefault(require("./images/device_tablet_apple_dark_portrait.png"));

var device_tablet_apple_light_landscape_png_1 = __importDefault(require("./images/device_tablet_apple_light_landscape.png"));

var device_tablet_apple_light_portrait_png_1 = __importDefault(require("./images/device_tablet_apple_light_portrait.png"));

var device_watch_android_dark_png_1 = __importDefault(require("./images/device_watch_android_dark.png"));

var device_watch_android_light_png_1 = __importDefault(require("./images/device_watch_android_light.png"));

var device_watch_apple_dark_png_1 = __importDefault(require("./images/device_watch_apple_dark.png"));

var device_watch_apple_light_png_1 = __importDefault(require("./images/device_watch_apple_light.png")); // Hashmap of Devices (object with typed key and value)


var Devices = {
  AppleWatch: {
    name: "AppleWatch",
    lightPath: device_watch_apple_light_png_1["default"],
    darkPath: device_watch_apple_dark_png_1["default"],
    device: {
      width: 248,
      height: 440
    },
    content: {
      x: 40,
      y: 122,
      width: 157,
      aspect: 4 / 5
    }
  },
  AndroidWatch: {
    name: "AndroidWatch",
    lightPath: device_watch_android_light_png_1["default"],
    darkPath: device_watch_android_dark_png_1["default"],
    device: {
      width: 245,
      height: 405
    },
    content: {
      x: 32,
      y: 106,
      width: 181,
      aspect: 1,
      borderRadius: 12
    }
  },
  ApplePhone: {
    name: "ApplePhone",
    lightPath: device_phone_apple_light_png_1["default"],
    darkPath: device_phone_apple_dark_png_1["default"],
    device: {
      width: 391,
      height: 477
    },
    content: {
      x: 102,
      y: 18,
      width: 750 / 4 + 1,
      aspect: 9 / 19.5
    }
  },
  AndroidPhone: {
    name: "AndroidPhone",
    lightPath: device_phone_android_light_png_1["default"],
    darkPath: device_phone_android_dark_png_1["default"],
    device: {
      width: 1112 / 4,
      height: 1854 / 4
    },
    content: {
      x: 197 / 4,
      y: 146 / 4,
      width: 720 / 4,
      aspect: 9 / 18
    }
  },
  AppleTablet: {
    name: "AppleTablet",
    lightPath: device_tablet_apple_light_portrait_png_1["default"],
    darkPath: device_tablet_apple_dark_portrait_png_1["default"],
    device: {
      width: 2332 / 4,
      height: 2810 / 4
    },
    content: {
      x: 398 / 4,
      y: 249 / 4,
      width: 1536 / 4,
      aspect: 3 / 4
    }
  },
  AppleTabletLandscape: {
    name: "AppleTabletLandscape",
    lightPath: device_tablet_apple_light_landscape_png_1["default"],
    darkPath: device_tablet_apple_dark_landscape_png_1["default"],
    device: {
      width: 3000 / 4,
      height: 2000 / 4
    },
    content: {
      x: 476 / 4,
      y: 201 / 4,
      width: 2048 / 4,
      aspect: 4 / 3
    }
  },
  AppleLaptop: {
    name: "AppleLaptop",
    lightPath: device_laptop_apple_light_png_1["default"],
    darkPath: device_laptop_apple_dark_png_1["default"],
    device: {
      width: 4036 / 4,
      height: 2190 / 4
    },
    content: {
      x: 578 / 4,
      y: 144 / 4,
      width: 2880 / 4,
      aspect: 16 / 10
    }
  },
  AppleDesktop: {
    name: "AppleDesktop",
    lightPath: device_desktop_apple_light_png_1["default"],
    darkPath: device_desktop_apple_dark_png_1["default"],
    device: {
      width: 3474 / 4,
      height: 2312 / 4
    },
    content: {
      x: 457 / 4,
      y: 111 / 4,
      width: 2560 / 4,
      aspect: 16 / 9
    }
  }
};
/**
 * The <Media /> Component displays an image or video inside a smartphone or tablet frame. The device type can be
 * chosen by setting the deviceType prop. For an image, an image URL needs to be passed via the imgSrc prop.
 * Alternatively, the URL video can be passed via the videoSrc/(vidSrc depr.) prop. The image ratios need to be choosen according
 * to the device image.
 * Useful link for the video functionality: https://www.w3.org/2010/05/video/mediaevents.html
 *
 * The prop videoAutoPlay enables an autoplay as soon as the video is 2/3 visible in the viewPort.
 * If the user once has stopped or started the video manually, or unmutes the video (by video controls),
 * the viewport autoplay function (start/stop) stops -> the video keeps playing when the viewport is left.
 * In both autoPlay cases, the video is muted, unless the user turns on the sound.
 * (By the way, chrome throws an error if the video is not muted on autoplay).
 * In the preset of the component, user controls are enabled. You can suppress the controls by using the
 * videoSuppressControl prop.
 * Normally, the video plays in a loop (restarts at the end) unless you turn it off by videoLoop={false}
 */

var Media =
/** @class */
function (_super) {
  __extends(Media, _super);

  function Media() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.fuzziness = 0.1; // this increases the size of the content area by the specified amount in percent - the increased size might be necessary for the content to cover all the devices screen space when zooming in/out with browser

    _this.uuid = _this.props.id || uniqid_1["default"]("lsg--media-");

    _this.onVideoPlayerError = function (event) {
      // thrown, when video is ready to play.
      if (!_this.isPlayerReady && _this.videoElementFallbackImage) {
        _this.videoElement.setAttribute("style", "display:none;");

        _this.videoElementFallbackImage.setAttribute("style", "display:block;");
      }

      if (_this.props.videoOnError) {
        _this.props.videoOnError(event);
      }
    };

    _this.handleVisibilityChange = function (visibleIds) {
      if (_this.videoElement) {
        if (visibleIds.length > 0) {
          _this.playVideo();
        } else {
          _this.pauseVideo();
        }
      }
    };

    _this.playVideo = function () {
      // this function is called by the Viewport Autoplayer ONLY
      // userInteraction: disable viewport autoplayer if there's been a user interaction (stop/pause)
      // isPlaying: unfortunately, there is no such thing as player.isPlaying(), so for best practice, use a variable
      if (_this.isPlayerReady && !_this.userInteraction && !_this.isPlaying) {
        var playPromise = _this.videoElement.play();

        if (playPromise !== undefined) {
          playPromise.then(function () {
            // Best practice: Use a promise.
            _this.isPlaying = true;
            _this.startedAutoplayByViewportEvent = true;
          });
        } else {
          // Fallback with IE11
          _this.isPlaying = true;
          _this.startedAutoplayByViewportEvent = true;
        }
      }
    };

    _this.pauseVideo = function () {
      // this function is called by the Viewport Autoplayer ONLY
      // userInteraction: disable viewport autoplayer if there's been a user interaction (stop/pause)
      if (_this.isPlayerReady && !_this.userInteraction && _this.isPlaying) {
        try {
          // for various reasons, the pause() method could not work/throw an exception - therefore the trycatch
          _this.videoElement.pause();

          _this.isPlaying = false;
          _this.stoppedAutoplayByViewportEvent = true;
        } finally {// nothing to do
        }
      }
    };

    _this.isNotStartOrEndOfTheVideo = function () {
      // this is needed to decide if there was a user interaction in the middle of the video.
      // the play and pause events are thrown in the start or end of the video
      // so to decide if there has been a user interaction as opposed to a restart of the video,
      // we use this function together with stoppedAutoplayByViewportEvent and startedAutoplayByViewportEvent
      var result = true;

      try {
        // this.videoElement.duration sometimes throws an exception - therefore the trycatch
        var _a = _this.videoElement,
            duration = _a.duration,
            currentTime = _a.currentTime;
        result = currentTime > duration * 0.02 && currentTime < duration * 0.98;
      } finally {// do nothing; result = true;
      }

      return result;
    };

    return _this;
  }

  Media.prototype.componentDidMount = function () {
    var _this = this;

    var videoSource = this.props.videoSrc || this.props.vidSrc; // videoSrc is deprecated

    if (videoSource && this.videoElement && this.props.videoAutoPlay) {
      // if it's a video, we have to deal with the autoplay functionality (start/stop on visibility change)
      this.videoElement.onplaying = function () {
        // this event is used to decide if there has been a user interaction
        // unfortunately, this event is also triggered on restart of the video (loop)
        // so we need the flag startedAutoplayByViewportEvent
        if (_this.isNotStartOrEndOfTheVideo()) {
          if (!_this.startedAutoplayByViewportEvent) {
            // the user started the video manually (could happen if video not completely in Viewport)
            _this.userInteraction = true;
          }

          _this.startedAutoplayByViewportEvent = false;
        }
      };

      this.videoElement.onpause = function () {
        // this event is used to decide if there has been a user interaction
        // unfortunately, this event is also triggered on end of the video (loop)
        // so we need the flag stoppedAutoplayByViewportEvent
        if (_this.isNotStartOrEndOfTheVideo()) {
          if (!_this.stoppedAutoplayByViewportEvent) {
            // the user stopped the video manually
            _this.userInteraction = true;
          }

          _this.stoppedAutoplayByViewportEvent = false;
        }
      };

      this.videoElement.onvolumechange = function () {
        // if the user turned on audio, turn off autoPlay
        if (_this.isNotStartOrEndOfTheVideo()) {
          _this.userInteraction = true;
        }
      };

      this.videoElement.oncanplay = function () {
        // thrown, when video is ready to play.
        if (!_this.isPlayerReady) {
          _this.isPlayerReady = true; // to make sure that the page was fully built up, delay the video;
          // else there could be problems with the autoPlay functionality

          setTimeout(function () {
            utils_1.WindowEvents.addVisibilityCallback(_this.handleVisibilityChange, [_this.videoElementMarker.id], utils_1.WindowEvents.Visibility.FULLY_VISIBLE);
          }, 1500);
        }
      };
    }
  };

  Media.prototype.componentWillUnmount = function () {
    // remove the event listener if the autoPlay functionality is enabled
    utils_1.WindowEvents.removeVisibilityCallback(this.handleVisibilityChange);
  };

  Media.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        deviceType = _a.deviceType,
        imgSrc = _a.imgSrc;
    var videoSource = this.props.videoSrc || this.props.vidSrc;
    return React.createElement("div", {
      id: this.uuid,
      className: CSSPrefix_1.lsgPre + "media"
    }, deviceType ? React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "media-device-frame"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "media-content",
      style: {
        left: 100 / deviceType.device.width * deviceType.content.x - this.fuzziness + "%",
        top: 100 / deviceType.device.height * deviceType.content.y - this.fuzziness + "%",
        width: 100 / deviceType.device.width * deviceType.content.width + 2 * this.fuzziness + "%",
        maxHeight: 100 / deviceType.device.height * deviceType.content.width / deviceType.content.aspect + 2 * this.fuzziness + "%",
        borderRadius: deviceType.content.borderRadius ? deviceType.content.borderRadius + "%" : 0
      }
    }, imgSrc && React.createElement(Picture_1.Picture, {
      className: CSSPrefix_1.lsgPre + "media-content-inner",
      src: imgSrc
    }), videoSource && React.createElement(React.Fragment, null, React.createElement("video", {
      className: CSSPrefix_1.lsgPre + "media-content-inner",
      controls: !this.props.videoSuppressControls,
      loop: this.props.videoLoop,
      ref: function ref(r) {
        _this.videoElement = r;
      },
      autoPlay: false,
      muted: this.props.videoAutoPlay,
      poster: this.props.videoPoster,
      src: videoSource,
      onError: this.onVideoPlayerError
    }, (this.props.videoFallbackImage || this.props.videoPoster) && React.createElement("img", {
      src: this.props.videoFallbackImage || this.props.videoPoster,
      title: this.props.videoNotSupportedText || "Your browser does not support the video tag."
    }) || this.props.videoNotSupportedText || "Your browser does not support the video tag."), (this.props.videoFallbackImage || this.props.videoPoster) && React.createElement("img", {
      id: this.uuid + "-video-fallback-image",
      className: CSSPrefix_1.lsgPre + "media-content-inner fallback-image",
      src: this.props.videoFallbackImage || this.props.videoPoster,
      ref: function ref(r) {
        _this.videoElementFallbackImage = r;
      }
    }), React.createElement("div", {
      id: this.uuid + "-video-viewport-marker",
      ref: function ref(r) {
        _this.videoElementMarker = r;
      },
      className: CSSPrefix_1.lsgPre + "media-content-video-viewport-marker"
    }))), React.createElement("img", {
      className: CSSPrefix_1.lsgPre + "media-device-frame__light",
      src: deviceType.lightPath,
      alt: "Device Frame"
    }), React.createElement("img", {
      className: CSSPrefix_1.lsgPre + "media-device-frame__dark",
      src: deviceType.darkPath,
      alt: "Device Frame"
    })) : React.createElement("div", null));
  };

  Media.defaultProps = {
    videoLoop: true
  };
  Media.Device = Devices;
  Media.displayName = "Media";
  return Media;
}(React.Component);

exports.Media = Media;